// extracted by mini-css-extract-plugin
export default {"buttons":"Gn3aGVI1"};